export default __webpack_public_path__ + "static/media/bogate_wyposazenie.823de288.jpg";